import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../ActionElement';
import { validatePropTypeDate } from '../../../common/utils';
import withLocalization from '../../higherOrderComponents/withLocalization';

const DayPickerNavBar = props => {
  const {
    translatedMonths,
    month,
    onPreviousClick,
    onNextClick,
    monthMin,
    monthMax,
    className,
    localeUtils,
    handleYearMonthChange,
    translate
  } = props;

  if (Number.isNaN(month.getMonth())) {
    throw new Error("Invalid date object passed to DayPickerNavBar's \"month\" prop");
  }

  const yearCurrent = month.getFullYear();
  const monthCurrent = month.getMonth();
  const dateMonthPrevious = new Date();
  const dateMonthNext = new Date();

  dateMonthPrevious.setMonth(monthCurrent - 1);
  dateMonthNext.setMonth(monthCurrent + 1);

  const previousMonth = dateMonthPrevious.getMonth();
  const nextMonth = dateMonthNext.getMonth();
  const yearNext = yearCurrent + 1;
  const yearPrev = yearCurrent - 1;
  const yearMin = monthMin.getFullYear();
  const yearMax = monthMax.getFullYear();
  const months = translatedMonths || localeUtils.getMonths();
  const monthNamePrev = months[previousMonth];
  const monthNameNext = months[nextMonth];

  return (
    <nav className={className}>
      <Button
        title={translate('navbar-button-month-prev-title', { monthNamePrev })}
        onClick={() => onPreviousClick()}
        appearance='buttonWrap'
        iconName='chevron-left'
        className='text-left'
        disabled={false}
        letButtonShrink
      >
        {monthNamePrev.slice(0, 3)}
      </Button>

      <div className='d-flex'>
        <Button
          onClick={() => handleYearMonthChange(yearPrev, monthCurrent)}
          appearance='buttonWrap'
          iconName='chevron-up'
          title={translate('navbar-button-year-prev-title', { yearPrev })}
          disabled={yearPrev < yearMin}
        />

        <span className='itemgap-left itemgap-right text-weight-bold'>{yearCurrent}</span>

        <Button
          onClick={() => handleYearMonthChange(yearNext, monthCurrent)}
          appearance='buttonWrap'
          iconName='chevron-down'
          title={translate('navbar-button-year-next-title', { yearNext })}
          disabled={yearNext > yearMax}
        />
      </div>

      <Button
        onClick={() => onNextClick()}
        appearance='buttonWrap'
        iconName='chevron-right'
        title={translate('navbar-button-month-next-title', { monthNameNext })}
        className='text-right'
        disabled={false}
        letButtonShrink
        pullIconRight
      >
        {monthNameNext.slice(0, 3)}
      </Button>
    </nav>
  );
};

DayPickerNavBar.propTypes = {
  translatedMonths: PropTypes.array,
  month: (props, propName, componentName) => validatePropTypeDate(props, propName, componentName, true),
  monthMin: (props, propName, componentName) => validatePropTypeDate(props, propName, componentName, true),
  monthMax: (props, propName, componentName) => validatePropTypeDate(props, propName, componentName, true),
  handleYearMonthChange: PropTypes.func.isRequired
};

export default withLocalization(DayPickerNavBar, 'elements/customDayPicker');